import Card from 'core/card'
import { CardPaddings } from 'core/card/enum'
import { getTimestampWithOffset } from 'core/utils/date-utils'
import { DEVICE_OS, DeviceShadow, GeneralDeviceState } from '../../general/redux/types'
import Topbar from '../../topbar/topbar-container'
import ClientSection from './components/ClientSection'
import StatusSection from './components/StatusSection'
import './index.scss'

type DeviceChecksProps = {
  id: string
  general: GeneralDeviceState
  offset: number
}

function getLastClientRealTimeUpdate(offset: number, shadow?: DeviceShadow) {
  if (!shadow) return 0

  const {software, status} = shadow.reported
  if (software.os === 'android') {
    return getTimestampWithOffset(parseInt(status.lastConnectionDate) * 1000, offset)
  }

  return getTimestampWithOffset(shadow.lastUpdateDateRcgShadowUpdate, offset)
}

function getVIPConnectivityCheck(offset:number, shadow?: DeviceShadow ) {
  if (!shadow) return 0


  return getTimestampWithOffset(Math.max((shadow.lastUpdateDateUserConversion * 1000), (shadow.lastUpdateDateDeviceMonitoring * 1000)), offset)
}

function getLastUpdateBy(shadow: DeviceShadow | undefined) {
  if (shadow) {
    if(shadow.reported.software.os === DEVICE_OS.ANDROID && shadow.reported.status.connected === 'true') {
      return 'RADIX'
    }

    return shadow.lastUpdateBy
  }

  return ''
}

export default function DeviceChecksComponent({ id, general, offset }: DeviceChecksProps) {
  const { shadow } = general

  return (
    <>
      <div className="columns width-full">
        <div className="column">
          <Topbar id={id} />
        </div>
      </div>
      <div className="tile is-vertical has-padding-left-none">
        <div className="tile is-parent is-vertical flex-zero has-padding-sm">
          <div className="tile is-child">
            <Card isFullHeight padding={CardPaddings.MEDIUM}>
              <ClientSection
                lastUpdateBy={getLastUpdateBy(shadow)}
                lastClientRealTimeDataUpdate={getLastClientRealTimeUpdate(offset, shadow)}
                connected={shadow?.reported.status.connected === 'true'}
                registeredInRCG={shadow?.lastUpdateDateRcgProvisioning || 0}
              />
              <StatusSection
                VIPConnectivityCheck={getVIPConnectivityCheck(offset, shadow)}
                STBMD={shadow?.custom.STBMD || ''}
                lastTechnicalDataEvent={shadow?.lastTechnicalDataEventDate || ''}
                clientDataBrokerCheck={shadow?.lastUpdateDateDeviceMonitoring ? 
                  getTimestampWithOffset(shadow.lastUpdateDateDeviceMonitoring * 1000, offset) :
                  0
                }
                authenticationTokenDate={shadow?.custom.AUTHN || ''}
                dvsd={shadow?.custom?.DVSD || ''}
                offset={offset}
              />
            </Card>
          </div>
        </div>
      </div>
    </>
  )
}
